import { NgModule } from '@angular/core';
import { AppSharedModule } from '../app-shared.module';
import { ComponentsModule } from '../components/components.module';
import { OrgaoJusticaEdicaoComponent } from './orgao-justica-edicao/orgao-justica-edicao.component';
import { OrgaoJusticaFrmComponent } from './orgao-justica-frm/orgao-justica-frm.component';
import { OrgaoJusticaListaComponent } from './orgao-justica-lista/orgao-justica-lista.component';
import { OrgaoJusticaRoutingModule } from './orgao-justica.routing';
import { OrgaoJusticaService } from './orgao-justica.service';
import { OrgaoJusticaVisualizacaoComponent } from './orgao-justica-visualizacao/orgao-justica-visualizacao.component';

@NgModule({
  imports: [
    AppSharedModule,
    ComponentsModule,
  ],
  declarations: [
    OrgaoJusticaListaComponent,
    OrgaoJusticaFrmComponent,
    OrgaoJusticaEdicaoComponent,
    OrgaoJusticaVisualizacaoComponent,

  ],
  exports: [
    OrgaoJusticaRoutingModule,
  ],
  providers: [
    OrgaoJusticaService
  ]
})
export class OrgaoJusticaModule { }
